import apiClient from '../api/api'
import { User } from '@/interfaces/user'

export const searchUsers = async (keyword: string): Promise<User[]> => {
  const response = await apiClient.get<User[]>('/users/search', {
    params: { keyword },
  })
  return response.data
}

export const getUserById = async (userId: string): Promise<User> => {
  const response = await apiClient.get<User>(`/users/${userId}`)
  return response.data
}
